import type { EiiApi } from "../../api/EiiApi";
import type { CreateEiiOverride } from "../../generated/dto/CreateEiiOverride";
import type { DeleteEiiOverrideStaff } from "../../generated/dto/DeleteEiiOverrideStaff";
import type { EiiApplicationRequest } from "../../generated/dto/EiiApplicationRequest";
import type { EiiApplicationStatus } from "../../generated/dto/EiiApplicationStatus";
import type { EiiCreateResponseRequest } from "../../generated/dto/EiiCreateResponseRequest";
import type { EiiMitStaff } from "../../generated/dto/EiiMitStaff";
import type { EiiOverrideSearchParams } from "../../generated/dto/EiiOverrideSearchParams";
import type { EiiOverrideStaff } from "../../generated/dto/EiiOverrideStaff";
import type { EiiOverrideStaffSearchResult } from "../../generated/dto/EiiOverrideStaffSearchResult";
import type { EiiResponseStaff } from "../../generated/dto/EiiResponseStaff";
import type { EiiResponseStaffSearchParams } from "../../generated/dto/EiiResponseStaffSearchParams";
import type { EiiResponseStaffSearchResult } from "../../generated/dto/EiiResponseStaffSearchResult";
import type { EiiUpdateResponseRequest } from "../../generated/dto/EiiUpdateResponseRequest";
import type { UpdateEiiOverride } from "../../generated/dto/UpdateEiiOverride";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class EiiFrontendService {
  constructor(private readonly api: EiiApi) {}
  private readonly eiiMitStaffCache: Map<number, EiiMitStaff> = new Map();
  async getEiiResponseStaff(id: number): Promise<EiiResponseStaff> {
    return this.api.getEiiResponseStaff(id)
  }
  async getEiiMitStaff(id: number): Promise<EiiMitStaff> {
    const __cached = this.eiiMitStaffCache.get(id);
    if (__cached !== undefined) {
      return __cached
    }
    const __value = await this.api.getEiiMitStaff(id);
    this.eiiMitStaffCache.set(id, __value);
    return __value
  }
  async getEiiOverrideStaff(id: number): Promise<EiiOverrideStaff> {
    return this.api.getEiiOverrideStaff(id)
  }
  async getAllEiiMitStaffs(): Promise<Array<EiiMitStaff>> {
    return this.api.getAllEiiMitStaffs()
  }
  async createEiiOverrideStaff(source: CreateEiiOverride): Promise<EiiOverrideStaff> {
    return this.api.createEiiOverrideStaff(source)
  }
  async updateEiiOverrideStaff(source: UpdateEiiOverride): Promise<EiiOverrideStaff> {
    return this.api.updateEiiOverrideStaff(source)
  }
  async deleteEiiOverrideStaff(source: DeleteEiiOverrideStaff): Promise<void> {
    return this.api.deleteEiiOverrideStaff(source)
  }
  async searchEiiResponseStaff(params: EiiResponseStaffSearchParams, page: number, perPage: number): Promise<PaginationResult<EiiResponseStaffSearchResult>> {
    return this.api.searchEiiResponseStaff(params, page, perPage)
  }
  async searchEiiOverrideStaff(params: EiiOverrideSearchParams, page: number, perPage: number): Promise<PaginationResult<EiiOverrideStaffSearchResult>> {
    return this.api.searchEiiOverrideStaff(params, page, perPage)
  }
  async searchEiiResponseStaffFull(params: EiiResponseStaffSearchParams, page: number, perPage: number): Promise<PaginationResult<EiiResponseStaff>> {
    return this.api.searchEiiResponseStaffFull(params, page, perPage)
  }
  async searchEiiOverrideStaffFull(params: EiiOverrideSearchParams, page: number, perPage: number): Promise<PaginationResult<EiiOverrideStaff>> {
    return this.api.searchEiiOverrideStaffFull(params, page, perPage)
  }
  async createResponseStaff(request: EiiCreateResponseRequest): Promise<EiiResponseStaff> {
    return this.api.createResponseStaff(request)
  }
  async currentApplicationMember(): Promise<EiiApplicationStatus> {
    return this.api.currentApplicationMember()
  }
  async submitApplicationMember(request: EiiApplicationRequest): Promise<EiiApplicationStatus> {
    return this.api.submitApplicationMember(request)
  }
  async updateResponseStaff(request: EiiUpdateResponseRequest): Promise<EiiResponseStaff> {
    return this.api.updateResponseStaff(request)
  }
}
